var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const INTERCOM_BASE = "api/intercom";
/**
 * Fetches a fresh Intercom Identity Verification token for the authenticated user.
 *
 * Use this when:
 * - Initializing Intercom Messenger after restoring a session from storage
 * - The token returned at login has expired (check expiresAt before calling)
 *
 * Pass `intercomJwt` if you already have a token — the backend will reuse it
 * if it still has more than 1 hour of life remaining, avoiding unnecessary resets.
 *
 * Requires: authenticated session (apiToken must be set on the client).
 */
export const getMessengerToken = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${INTERCOM_BASE}/messenger-token`, params !== null && params !== void 0 ? params : {}, config);
        }
        catch (error) {
            console.error('Error fetching intercom messenger token:', error);
            throw error;
        }
    });
};
